import instance from './instance';
import config from '../config';

const TRANSACTION_BASE_URL = config.routes.transactions;

export function getLeaseTransactions(leaseId) {
  return instance.get(`${TRANSACTION_BASE_URL}/${leaseId}`);
}
